var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"placeholder"},[_c('div',{staticClass:"placeholderBox"},[_c('img',{staticClass:"placeholderImg",attrs:{"src":require("assets/img/other/icon_placeholder.png")}}),_c('div',{staticClass:"placeholderText"},[_vm._v(_vm._s(_vm.$t.meta.noMore))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }